import React from 'react';
import { Flex, Text, Button, HStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

// MI-297: intentional empty state — the safety net for anything skipped in the
// wizard. A headline + subtitle + one or two CTAs instead of a blank list.
// `actions` is an array of { label, onClick, primary? }.
export default function OnboardingEmptyState({ titleKey, subtitleKey, actions = [] }) {
  const { t } = useTranslation('onboarding');
  return (
    <Flex
      justify="center"
      align="center"
      direction="column"
      py={12}
      px={4}
      textAlign="center"
      bg="redesign.bg.surface"
      borderRadius="md"
      boxShadow="sm"
    >
      <Text fontSize="xl" fontWeight="semibold" color="redesign.heading">{t(titleKey)}</Text>
      <Text color="redesign.text.muted" mt={2} mb={5} maxW="380px">{t(subtitleKey)}</Text>
      <HStack spacing={3}>
        {actions.map((a, i) => (
          <Button
            key={i}
            variant={a.primary ? 'primary' : 'outline'}
            borderColor="redesign.border.strong"
            onClick={a.onClick}
          >
            {t(a.label)}
          </Button>
        ))}
      </HStack>
    </Flex>
  );
}
